import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatDialog } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { DataService } from 'src/app/services/data.service';
import { IActivity, IVocabulary } from 'src/app/interfaces/resource';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService, pushObjArray } from 'src/app/services/convert.service';
import { COLLECTION_NAME, FILE_FOLDER } from 'src/app/dummy/app';
import { Observable } from 'rxjs';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { Router } from '@angular/router';
import { AddPictureQuestionComponent } from '../add-picture-question/add-picture-question.component';

@Component({
  selector: 'app-add-picture-description-exercise',
  templateUrl: './add-picture-description-exercise.component.html',
  styleUrls: ['./add-picture-description-exercise.component.scss']
})
export class AddPictureDescriptionExerciseComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  @ViewChild('pictureFile',{static:false}) pictureFile: ElementRef;

  TITLE = "Create picture description exercise"

  form: FormGroup;
  question: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  SELECTED_SOUND_FILE: any;
  uploadPercent: Observable<number>
  START_UPLOAD: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddPictureDescriptionExerciseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: ActivityStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private storage: FireStorageService,
    private route: Router,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    const { EXERCISE } = this.data;
    this.store.options = EXERCISE ? EXERCISE.answers : [];
    this.form = this.fb.group({
      question: [EXERCISE ? EXERCISE.word : null, Validators.compose([Validators.required])],
    })
    if (EXERCISE) {
      this.TITLE = "Edit picture description exercise";
    }
  }

  delete(item: any) {
    this.store.options = this.store.options.filter(m => m.key !== item.key) || [];
  }

  addNewLine(item: any) {
    let dialogRef = this.dialog.open(AddPictureQuestionComponent, {
      data: {
        QUESTION: this.data.QUESTION || {},
        ANSWER: item || null,
      },
      panelClass: 'item-list-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  uploadFileSound(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_SOUND_FILE = event.target.files[0];
      this.pictureFile.nativeElement.value = "";
    }
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    const { FORM, SKILL, ACTIVITY_TYPE, MODULE_KEY, ITEM, ACTIVITY_TYPE_OBJECT, SKILL_NAME, EXERCISE } = this.data;
    if (!this.SELECTED_SOUND_FILE && !EXERCISE) {
      alert('Please select sound file');
      return;
    }
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { question } = f;
      const key = ITEM ? ITEM.key : this.ds.createId();
      const wordKey = EXERCISE ? EXERCISE.key : this.ds.createId();
      const { name, instruction, defaultInstruction } = FORM;
      const { user, selectedCompanyKey } = this.auth;
      const questions = ITEM ? ITEM.questions : [];
      const registerStatus = STATUS_OBJECT.submitted;
      const { options } = this.store;
      const activity: IActivity = {
        key: key,
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name || null,
        instruction: instruction || null,
        defaultInstruction: defaultInstruction || false,
        questions: questions,
        hasSubActivity: true,
        //module
        skillKey: SKILL,
        skillRef: this.ds.skillRef().doc(SKILL).ref,
        skillName: SKILL_NAME,
        activityTypeKey: ACTIVITY_TYPE,
        activityTypeRef: this.ds.activityTypeRef().doc(ACTIVITY_TYPE).ref,
        activityTypeName: ACTIVITY_TYPE_OBJECT.name,
        moduleKey: MODULE_KEY,
        moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(MODULE_KEY).ref,
      }

      let wordData: any = {
        word: `${question}`.trim(),
        key: wordKey,
        pictureFileName: EXERCISE ? EXERCISE.pictureFileName : null,
        picturePath: EXERCISE ? EXERCISE.picturePath : null,
        pictureDownloadURL: EXERCISE ? EXERCISE.pictureDownloadURL : null,
        answers: options,
        pictureFile: EXERCISE ? EXERCISE.pictureFile || null : null,
      };

      if (this.SELECTED_SOUND_FILE) {
        this.START_UPLOAD = true;
        const file = this.SELECTED_SOUND_FILE;
        const fileName = file.name;
        const uploadPath = `${FILE_FOLDER.TRAINING_RESOURCES}/${this.ds.createId()}_${fileName}`;
        const uploadTask = this.storage.uploadSelectedFile(file, uploadPath);
        this.uploadPercent = uploadTask.percentageChanges();
        const files = await this.storage.getFileDetail(file, uploadPath, uploadTask)
        wordData = {
          word: `${question}`.trim(),
          key: wordKey,
          pictureFileName: fileName,
          picturePath: uploadPath,
          pictureDownloadURL: files.downloadUrl,
          answers: options,
          pictureFile: files
        };
      }
      const QUESTION_DATA = pushObjArray(questions || [], wordData);
      activity.questions = QUESTION_DATA;
      this.store.addItem(activity, this.data.MODULE, true, (success, res) => {
        if (!success) {
          alert(res)
          return;
        }
        this.data.ITEM = activity;
        this.snackBar.open("Picture description has been saved successful.", "Done", { duration: 1000 });
        if (!isNew) {
          this.route.navigate([`/modules/activity-type/${ACTIVITY_TYPE}/${SKILL}/${MODULE_KEY}/${activity.key}`])
          this.dialogRef.close('no')
          return;
        }
        this.form.reset();
        this.form.enable();
        this.form.patchValue({ isFill: false })
        this.store.options = [];
        this.pictureFile.nativeElement.value = "";
        this.processNew = false;
        this.processClose = false;
        this.SELECTED_SOUND_FILE = null;
        this.START_UPLOAD = false;
        this.isCreate = false;
        this.inputEl.nativeElement.focus()
        this.route.navigate([`/modules/activity-type/${ACTIVITY_TYPE}/${SKILL}/${MODULE_KEY}/${activity.key}`])
      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}